
<div class="notification-bar" *ngIf ="showNotificationHtml">
    <div class="notification-header">
        <div class="d-flex flex-row align-items-center justify-content-between header-resolve-inquiry">
            <h6 class="notification-title">Notifications</h6>
            <div class="close-button" (click)="closePanel()">
                <img src="assets/qwyn/icons/close.svg" alt="close">
            </div>
        </div>
    </div>
    <div>
        <div class="nav d-flex align-items-center flex-column flex-nowrap">
            <div (click)="onOptionClick(0)" class="w-111 px-4 pt-2" [class.active]='clickStatusArray[0]' >
                <div class="d-flex align-items-center justify-content-end flex-row flex-nowrap active mb-2 pe-2" *ngIf="this.notificationArray.length>1">
                    <div class="unread-text">Unread</div>
                    <div class="divider"></div>
                    <div class="clickable-cursor d-flex flex-row align-items-center" (click)="dismissAll();closePanel();">Dismiss All</div>
                </div>
                <div *ngIf="this.notificationArray.length == 0" class="notification-message">
                    <p class="bold-text">You are all caught up!</p>
                    <p class="normal-text">You have no new notifications</p>
                </div>
                <ng-scrollbar class="notification-scrollbar"
                              [invertY]="false"
                              [trackX]="false"
                              [compact]="false"
                              [shown]="native"
                              [autoUpdate]="true">
                    <ul class="p-0 notification-text grey-color scrollable-list">
                        <ng-container *ngFor="let item of notificationArray; let i = index">
                            <!-- Yesterday divider -->
                            <div *ngIf="isYesterday(item.crtDate.$date) &&
                           (!notificationArray[i-1] || !isYesterday(notificationArray[i-1].crtDate.$date))"
                                 class="d-flex align-items-center mb-2">
                                <div class="yesterday-text">Yesterday</div>
                                <div class="divider"></div>
                            </div>
                            <li class="d-flex flex-row flex-wrap mb-1 pe-1 subMenu"
                                [ngClass]="{
                                'subMenu-escalation': item.action == 'Escalation',
                                'subMenu-unsnooze': item.action == 'Un-Snooze',
                                'subMenu-nomination': item.action == 'Assign Owner',
                                'subMenu-approval': item.action == 'Approved' || item.subject == 'Accepted',
                                'subMenu-reject': item.action == 'Reject' || item.subject == 'Rejected',
                                'subMenu-followup': item.action == 'FollowUp',
                                'subMenu-snooze': item.action == 'Snooze',
                                'subMenu-pending-approval': item.action == 'Pending Approval'
                            }" [@items]>

                                <div class="notification-text-cont">
                                    <div class="inquiry-action-content">{{item.action}}</div>
                                    <div class="m-0 inquiry-header text-truncate">{{item.origSubject}}</div>
                                    <div class="inquiry-content">ID: {{item._id}}</div>
                                </div>
                                <div class="d-flex align-items-end flex-column flex-nowrap" >
                                    <div class="d-flex align-items-end flex-row flex-nowrap justify-content-end mt-1" style="gap: 15px;">
                                        <div (click)="viewNotification(item);closePanel();" class="qma-text right-content d-flex align-items-center flex-column flex-nowrap pe-2">
                                            <img src="assets/core/layout/tabs/notification_view.svg" style="width:20px; height:20px; cursor:pointer; padding:0px;" alt="View">
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <img src="assets/core/layout/tabs/divider.svg" style="width:1px; height:18px;" alt="Divider">
                                        </div>
                                        <div (click)="dismissNotification(item);closePanel();" class="qma-text right-content d-flex align-items-center flex-column flex-nowrap">
                                            <img src="assets/core/layout/tabs/notification_close.svg" style="width:20px; height:18px; cursor:pointer; padding-bottom:5px;" alt="Close">
                                        </div>
                                    </div>
                                    <div class="inquiry-date">{{item.crtDate.$date | date:'MMM d, y' }}</div>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </ng-scrollbar>
            </div>
      </div>
  </div>
</div>
